/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  queryOptions as queryOptionsBuilder,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  EmptyTreeInfo,
  GetGenreTreeParams
} from '../../model';

import { customInstance } from '../../../mutator.ts';
import type { ErrorType } from '../../../mutator.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetGenreTreeUrl = (params?: GetGenreTreeParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Genre/GetGenreTree?${stringifiedParams}` : `/api/Genre/GetGenreTree`
}

export const getGenreTree = async (params?: GetGenreTreeParams, options?: Parameters<typeof customInstance>[1]): Promise<EmptyTreeInfo> => {

  return customInstance<EmptyTreeInfo>(getGetGenreTreeUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetGenreTreeQueryKey = (params?: GetGenreTreeParams,) => {
    return [
    `/api/Genre/GetGenreTree`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetGenreTreeQueryOptions = <TData = Awaited<ReturnType<typeof getGenreTree>>, TError = ErrorType<unknown>>(params?: GetGenreTreeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGenreTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGenreTreeQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGenreTree>>> = ({ signal }) => getGenreTree(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getGenreTree>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetGenreTreeQueryResult = NonNullable<Awaited<ReturnType<typeof getGenreTree>>>
export type GetGenreTreeQueryError = ErrorType<unknown>


export function useGetGenreTree<TData = Awaited<ReturnType<typeof getGenreTree>>, TError = ErrorType<unknown>>(
 params: undefined |  GetGenreTreeParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGenreTree>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGenreTree>>,
          TError,
          Awaited<ReturnType<typeof getGenreTree>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGenreTree<TData = Awaited<ReturnType<typeof getGenreTree>>, TError = ErrorType<unknown>>(
 params?: GetGenreTreeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGenreTree>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGenreTree>>,
          TError,
          Awaited<ReturnType<typeof getGenreTree>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGenreTree<TData = Awaited<ReturnType<typeof getGenreTree>>, TError = ErrorType<unknown>>(
 params?: GetGenreTreeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGenreTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetGenreTree<TData = Awaited<ReturnType<typeof getGenreTree>>, TError = ErrorType<unknown>>(
 params?: GetGenreTreeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGenreTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetGenreTreeQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetGenreTreeSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getGenreTree>>, TError = ErrorType<unknown>>(params?: GetGenreTreeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getGenreTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGenreTreeQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGenreTree>>> = ({ signal }) => getGenreTree(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getGenreTree>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetGenreTreeSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getGenreTree>>>
export type GetGenreTreeSuspenseQueryError = ErrorType<unknown>


export function useGetGenreTreeSuspense<TData = Awaited<ReturnType<typeof getGenreTree>>, TError = ErrorType<unknown>>(
 params: undefined |  GetGenreTreeParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getGenreTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGenreTreeSuspense<TData = Awaited<ReturnType<typeof getGenreTree>>, TError = ErrorType<unknown>>(
 params?: GetGenreTreeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getGenreTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGenreTreeSuspense<TData = Awaited<ReturnType<typeof getGenreTree>>, TError = ErrorType<unknown>>(
 params?: GetGenreTreeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getGenreTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetGenreTreeSuspense<TData = Awaited<ReturnType<typeof getGenreTree>>, TError = ErrorType<unknown>>(
 params?: GetGenreTreeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getGenreTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetGenreTreeSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






